import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import FlexportDutyDrawback from './flexportDutyDrawback/FlexportDutyDrawback'
import { BoxArrowInDown, CalendarEvent, ExclamationCircle, HouseExclamation, Passport } from 'react-bootstrap-icons'
import { Button } from 'react-bootstrap'
import { useState } from 'react'
import { CommonProperties } from '../common/common.interfaces'
import { FlexportProductSync } from './flexportProductSync/components/FlexportProductSync'
import { ErrorLogsByFunctionApp } from '../common/components/ErrorLogsByFunctionApp'
import { FlexportMilestoneEvents } from './flexportMilestones/components/FlexportMilestoneEvents'

interface FlexportProps extends CommonProperties {}

export function Flexport(props: FlexportProps) {
  const [tabIndex, setTabIndex] = useState(0)
  const [title, setTitle] = useState<string>('Flexport - Home')
  
  function switchTab(index: number, title: string){
    setTitle(`Flexport - ${title}`)
    setTabIndex(index)
  }

  return <div>
    <div className='beacon-card'>
      <span className='beacon-header'>{title}</span>
      <br/>
      <span className='beacon-label'>The Flexport app contains various activities to choose from. Select a tab below to get started.</span>
    </div>
    <Tabs selectedIndex={tabIndex}>
      <TabList className='beacon-header'>
        <Tab onClick={() => switchTab(0, 'Home')}><HouseExclamation size={25} /> HOME</Tab>
        <Tab onClick={() => switchTab(1, 'Duty Drawback Exports')}><Passport size={25} /> DUTY DRAWBACK EXPORT</Tab>
        <Tab onClick={() => switchTab(2, 'Webhook Milestones & Events')}><CalendarEvent size={25} /> MILESTONES & EVENTS</Tab>
        {/* <Tab onClick={() => switchTab(3, 'Product Sync')}><BoxArrowInDown size={25} /> PRODUCT SYNC</Tab> */}
        <Tab onClick={() => switchTab(3, 'Errors')}><ExclamationCircle size={25} /> ERRORS</Tab>

      </TabList>
      <TabPanel>
        <div style={{display: 'flex', flex: 'wrap', gap: '5px'}}>
          <div className='beacon-card'>
            <div className='beacon-header'>
              Duty Drawbacks Export
            </div>
            <div className='beacon-label'>
              This app allows users to export order items with required fields by week so that administrators can submit the data to Flexport upon request.
            </div>
            <Button variant='outline-secondary' onClick={() => {switchTab(1, 'Duty Drawback Exports')}}>GO</Button>
          </div>
          <div className='beacon-card'>
            <div className='beacon-header'>
              Webhook Milestones & Events
            </div>
            <div className='beacon-label'>
              This app allows users to view and manage webhook milestones and events that have be submitted to us by Flexport.
            </div>
            <Button variant='outline-secondary' onClick={() => {switchTab(2, 'Webhook Milestones & Events')}}>GO</Button>
          </div>
          {/* <div className='beacon-card'>
            <div className='beacon-header'>
              Product Sync
            </div>
            <div className='beacon-label'>
              This app allows users to view and manage product sync records that have been submitted to Flexport.
            </div>
            <Button variant='outline-secondary' onClick={() => {switchTab(3, 'Product Sync')}}>GO</Button>
          </div> */}
          <div className='beacon-card'>
            <div className='beacon-header'>
              Errors
            </div>
            <div className='beacon-label'>
              This app allows users to view errors for any of the functions in our Flexport app.
            </div>
            <Button variant='outline-secondary' onClick={() => {switchTab(3, 'Errors')}}>GO</Button>
          </div>
        </div>
      </TabPanel>
      <TabPanel >
        <FlexportDutyDrawback />
      </TabPanel>
      <TabPanel>
        <FlexportMilestoneEvents isAdmin={props.isAdmin} />
      </TabPanel>
      {/* <TabPanel>
        <FlexportProductSync isAdmin={props.isAdmin} />
      </TabPanel> */}
      <TabPanel>
        <ErrorLogsByFunctionApp environment={'production'} partitionKey={'flexport'} isAdmin={props.isAdmin} />
      </TabPanel>
    </Tabs>
  </div>
}